import * as Yup from 'yup';

const ModalConfirmAddressSchema = Yup.object().shape({
  zipcode: Yup.string().when('state', {
    is: 'EX',
    then: Yup.string().required('O campo ZIP Code é obrigatório'),
    otherwise: Yup.string().length(8, 'Formato do CEP inválido').required('O campo CEP é obrigatório'),
  }),
  street: Yup.string().max(120).required('O campo endereço é obrigatório'),
  neighborhood: Yup.string().max(40).required('O campo bairro é obrigatório'),
  state: Yup.string().max(2).required('O campo estado é obrigatório'),
  number: Yup.number()
    .max(99999)
    .when('noNumber', {
      is: false,
      then: (schema) => schema.required('O campo número é obrigatório'),
    }),
  city: Yup.mixed().test('city', 'O campo cidade é obrigatório', (currentValue) => {
    return !!currentValue?.value || !!currentValue;
  }),
  phone: Yup.string().required('O campo telefone é obrigatório'),
  additionalInfo: Yup.string().max(120).optional(),
});

export default ModalConfirmAddressSchema;
